import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { isRouteErrorResponse, Link as RouterLink, useRouteError } from 'react-router';

function ErrorLayout({ title, message }: { title: string; message: string }) {
  return (
    <Box sx={{ minHeight: '60vh', display: 'grid', placeItems: 'center', textAlign: 'center', p: 3 }}>
      <Box>
        <Typography variant="h2" component="h1">
          {title}
        </Typography>
        <Typography color="text.secondary" sx={{ mt: 1, mb: 3 }}>
          {message}
        </Typography>
        <Button component={RouterLink} to="/" variant="contained">
          Go to dashboard
        </Button>
      </Box>
    </Box>
  );
}

export function NotFoundPage() {
  return <ErrorLayout title="Page not found" message="The page you're looking for doesn't exist." />;
}

/** Shown when a route crashes while rendering or loading. */
export function RouteErrorPage() {
  const error = useRouteError();
  if (isRouteErrorResponse(error) && error.status === 404) return <NotFoundPage />;
  return <ErrorLayout title="Something went wrong" message="This page hit an unexpected error. Try again later." />;
}
